
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blackfriday",
      function () {
        return require("private-next-pages/blackfriday/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blackfriday"])
      });
    }
  